/**
 * Server-side auth policy, mirrored as constants.
 *
 * None of it is echoed in any response yet (backend ask W-A2), so these are
 * kept in sync by hand with HexagieApp `src/shared/services/authPolicy.ts`.
 * If the server starts returning policy in the `start` response, read it from
 * there and delete this file.
 */

export const OTP_LENGTH = 6;

export const OTP_TTL_SECONDS = 300;

export const RESEND_COOLDOWN_SECONDS = 30;

/** Then lockout until the window passes. There is no wrong-attempt counter. */
export const MAX_OTP_REQUESTS = 3;

export const OTP_REQUEST_WINDOW_HOURS = 12;

export const AUTH_SESSION_TTL_SECONDS = 3600;

export const AUTH_TOKEN_TTL_SECONDS = 86400;

export const UPLOAD_URL_TTL_SECONDS = 600;

export const ACCESS_URL_TTL_SECONDS = 3600;

export const ALLOWED_AVATAR_MIME_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
];

export const isAllowedAvatarMime = (mimeType) =>
  ALLOWED_AVATAR_MIME_TYPES.includes(String(mimeType).toLowerCase());
